import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "d-sm-flex align-items-center" }, null, -1)
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "bg-transparent text-primary transition p-0 border-0"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search-interface-symbol" })
], -1)
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Nom / Raison social "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Numéro Ifu "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Email "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Secteur d'activité "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Type de Marchand "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0"
    }, "ACTIONS")
  ])
], -1)
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text pe-0" }
const _hoisted_16 = { class: "dropdown" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge text-white bg-primary fs-15 dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createTextVNode(" Actions "),
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
], -1)
const _hoisted_18 = { class: "dropdown-menu" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_23 = { key: 2 }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_26 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          class: "search-box position-relative me-15",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
            onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
            class: "form-control shadow-none text-black rounded-0 border-0",
            placeholder: "Rechercher un marchand"
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _hoisted_5
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("table", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.marchands, (marchand, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_10, _toDisplayString(marchand.nom) + " " + _toDisplayString(marchand.prenom) + " " + _toDisplayString(marchand.raisonSocial), 1),
                _createElementVNode("td", _hoisted_11, _toDisplayString(marchand.ifu), 1),
                _createElementVNode("td", _hoisted_12, _toDisplayString(marchand.email), 1),
                _createElementVNode("td", _hoisted_13, _toDisplayString(marchand.secteurActivite.libelle), 1),
                _createElementVNode("td", _hoisted_14, _toDisplayString(marchand.typeMarchand === "1" ? "Personne Physique" : "Personne Morale"), 1),
                _createElementVNode("td", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("ul", _hoisted_18, [
                      (_ctx.checkPermission('EditMarchand'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                            _createVNode(_component_router_link, {
                              to: { name: 'EditMarchandPage', params: { id: marchand.id } },
                              class: "dropdown-item d-flex align-items-center"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_20,
                                _createTextVNode("Modifier")
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.checkPermission('ViewMarchand'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                            _createVNode(_component_router_link, {
                              to: { name: 'ViewMarchandPage', params: { id: marchand.id } },
                              class: "dropdown-item d-flex align-items-center"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_22,
                                _createTextVNode("Détails")
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.checkPermission('DeleteMarchand'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                            _createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);",
                              onClick: ($event: any) => (_ctx.suppression(marchand.id,_ctx.marchands,'marchands',`le marchand ${marchand.nom}`))
                            }, [
                              _hoisted_25,
                              _createTextVNode(" Supprimer ")
                            ], 8, _hoisted_24)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}